import axios from 'axios';
const instanse = axios.create({
  baseURL: 'https://us-central1-challange-nuhla.cloudfunctions.net/api', /// the api (cloud function )url
});

export default instanse;
